import React from 'react';
import { CopyContentButton } from 'Shared/components/CopyContentButton';
import { formatAttributeValue } from 'BlockList/utils/formatAttributeValue';
import type { AttributeTypeKey } from 'BlockList/types';
import styles from './AttributeValueCell.module.css';

type AttributeValueCellProps = {
  attributeType: AttributeTypeKey;
  value: string;
};

export const AttributeValueCell: React.FC<AttributeValueCellProps> = ({
  attributeType,
  value,
}) => (
  <span className={styles.cell}>
    <span className={styles.content}>
      {formatAttributeValue(attributeType, value)}
    </span>
    {value && (
      <span className={styles.copyIcon}>
        <CopyContentButton value={value} />
      </span>
    )}
  </span>
);
